import { useState, useEffect } from "react";
import { useNavigate } from "react-router";
import TableClasses from "Components/TableLoad";

import { FiPlus } from "react-icons/fi";
import { IoPencil } from "react-icons/io5";
import { MdDelete } from "react-icons/md";

import ImagePreview from "Components/ImagePreview";
import Moment from "react-moment";
import {
    showErrorAlert,
    showWarningAlert,
    confirmAction,
    Toast,
} from "Util/Alerts";

import { configType } from "./configType";

import { getAllConfig, Delete_Banner } from "Services/Requests";
// import {  } from "Util/Alerts";
import Styles from "Styles/Styles.module.css";

function ConfigComp() {
    const Navigate = useNavigate();
    let TableHead = ["KEY", "VALUE", "ACTIONS"];
    const [config, setconfig] = useState<configType[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    // State to handle modal visibility and the selected image
    const [isModalVisible, setIsModalVisible] = useState<boolean>(false);
    const [selectedImage, setSelectedImage] = useState<string | null>(null);

    const getconfig = async () => {
        try {
            const response = await getAllConfig();
            if (response?.data?.status === 1) {
                setconfig(response?.data?.data);
            } else {
                showWarningAlert(response?.data?.Message);
            }
        } catch (err: any) {
            showErrorAlert(
                err?.response?.data?.Message ||
                    err?.response?.data?.message ||
                    "Something went wrong try again later"
            );
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getconfig();
    }, []);

    // Function to close the modal
    const handleCancel = () => {
        setIsModalVisible(false);
        setSelectedImage(null);
    };

    return (
        <div className={Styles["Container"]}>
            <ImagePreview
                handleCancel={handleCancel}
                isModalVisible={isModalVisible}
                selectedImage={selectedImage}
                title="Banner"
            />
            <header>
                <h3>config</h3>
            </header>
            {/*  <div className={Styles["filter"]}>
                <p>Filter By :</p>
                <select>
                    <option value="0">All</option>
                    <option value="1">Home config</option>
                    <option value="2">Promotional Banner</option>
                </select>
            </div> */}
            {loading ? (
                <TableClasses TableHead={TableHead} />
            ) : (
                <div className={Styles["tableWrapper"]}>
                    <table>
                        <thead>
                            {TableHead.map((item) => (
                                <th>{item}</th>
                            ))}
                        </thead>
                        <tbody>
                            {config.length > 0 ? (
                                config?.map((item) => (
                                    <tr key={item?.config_id}>
                                        <td>{item.config_key}</td>
                                        <td>{item.config_value}</td>
                                        <td>
                                            <div
                                                className={
                                                    Styles["Action_Tabs"]
                                                }>
                                                <button
                                                    onClick={() =>
                                                        Navigate(
                                                            "/auth/config/edit",
                                                            { state: item }
                                                        )
                                                    }>
                                                    <IoPencil size={24} />
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan={TableHead.length}>
                                        No Banner Found
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
}

export default ConfigComp;
